import styled from 'styled-components';
export const TransparentButton = styled.button `
  border: none;
  cursor: pointer;
  background: none;
  padding: 0;
`;
//# sourceMappingURL=TransparentButton.js.map